// Copyright (c) 2016 Deere & Company

import './product-info-panel.scss';
import React, {PropTypes} from 'react';
import AmountOfUseWithModal from '../../../../shared/components/amount-of-use-with-modal';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Modal from '../../state/modal';
import PipStatus from '../../components/pip-status';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductImage from './../../../../shared/components/product-image';
import ProductStatusLink from '../../components/product-status-link';
import {buildDate} from '../../../../shared/services/build-date';
import {buildNumber} from '../../../../shared/services/build-number';

const ProductInfoPanel = props =>
    <section className='product-info-panel'>
        <div className='product-image'>
            <ProductImage
                imageURL={props.product.imageUrl}
                placeHolderText={props.product.baseMachineCode}
            />
        </div>
        <div className='product-info'>
            <div className='row'>
                {props.product.pipIndicator.status && props.isSapUp &&
                    <div className='pip-status-link'>
                        <PipStatus
                            pin={props.product.pin}
                            pipIndicator={props.product.pipIndicator}
                        />
                    </div>
                }
            </div>
            <div className='row'>
                <LabeledString
                    className='model'
                    data={props.product.model}
                    label='MODEL'
                />
                <LabeledString
                    className='days-rented'
                    data={buildNumber(props.product.daysRented)}
                    label='DAYS_ON_RENT'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='base-machine'
                    data={props.product.baseMachineCode}
                    label='BASE_MACHINE'
                />
                <LabeledString
                    className='maintenance-plan'
                    data={props.product.maintenancePlan}
                    label='MAINTENANCE_PLAN'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='build-date'
                    data={buildDate(props.product.buildDate)}
                    label='BUILT'
                />
                <AmountOfUseWithModal
                    actions={props.actions}
                    amountOfUseHistory={props.amountOfUseHistory}
                    isAmountOfUseModalOpen={props.isAmountOfUseModalOpen}
                    isSapUp={props.isSapUp}
                    isUpdateAmountOfUseModalOpen={props.isUpdateAmountOfUseModalOpen}
                    measurementReadings={props.measurementReadings}
                    onAmountOfUseModalClose={props.onAmountOfUseModalClose}
                    onAmountOfUseModalOpen={props.onAmountOfUseModalOpen}
                    onUpdateAmountOfUseModalClose={props.onUpdateAmountOfUseModalClose}
                    onUpdateAmountOfUseModalOpen={props.onUpdateAmountOfUseModalOpen}
                    product={props.product}
                    updateAmountOfUseMeasurement={props.updateAmountOfUseMeasurement}
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='delivery-date'
                    data={buildDate(props.product.deliveryDate)}
                    label='DELIVERED'
                />
                <ProductStatusLink
                    changeModalVisibility={props.changeModalVisibility}
                    product={props.product}
                    productStatusChangeModal={props.productStatusChangeModal}
                    updateStatus={props.updateStatus}
                />
            </div>
            <div className='row'>
                { props.product.isIrcPin &&
                    <FormattedMessage id='IRC_PIN_MESSAGE'/>
                }
            </div>
        </div>
    </section>;

ProductInfoPanel.displayName = 'ProductInfoPanel';
ProductInfoPanel.propTypes = {
    actions: PropTypes.object,
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)),
    changeModalVisibility: PropTypes.func.isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    isUpdateAmountOfUseModalOpen: PropTypes.bool,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onAmountOfUseModalClose: PropTypes.func.isRequired,
    onAmountOfUseModalOpen: PropTypes.func.isRequired,
    onUpdateAmountOfUseModalClose: PropTypes.func,
    onUpdateAmountOfUseModalOpen: PropTypes.func,
    product: PropTypes.instanceOf(Product).isRequired,
    productStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    updateAmountOfUseMeasurement: PropTypes.instanceOf(MeasurementReading),
    updateStatus: PropTypes.func.isRequired
};
ProductInfoPanel.defaultProps = {
    isSapUp: true
};

export default ProductInfoPanel;



// WEBPACK FOOTER //
// ./src/product/shared/components/product-info-panel/product-info-panel.js